<template>
  <p class="mb-0">
      Hotline: <a class="text-black" href="tel:1900.63.64.88">1900.63.64.88</a> <br/>
      Email: <a class="text-black" href="mailto:hotro@mpos.vn">hotro@mpos.vn</a>
  </p>
</template>
<script>

export default {
  name: 'Support',
  data: () => {
    return {
     
    }
  }
}
</script>
